import { Box, Text } from '@chakra-ui/react';

interface InfoBoxProps {
  title: string;
  description: string;
  highlight?: string;
  borderColor?: string;
  bg?: string;
}

export function InfoBox({ title, description, highlight, borderColor = '#3B82F6', bg = '#EFF6FF' }: InfoBoxProps) {
  return (
    <Box
      width="100%"
      paddingX="5%"
    >
      <Box
        borderLeft="4px solid"
        borderLeftColor={borderColor}
        bg={bg}
        borderRadius="8px"
        padding="16px 20px"
        width="100%"
      >
        <Text fontWeight="700" fontSize="14px" color="gray.700" marginBottom="4px">
          {title}
        </Text>
        <Text fontSize="13px" color="gray.600" lineHeight="1.5">
          {description}
        </Text>
        {highlight && (
          <Text fontSize="13px" fontWeight="700" color="gray.700" lineHeight="1.5" marginTop="8px">
            {highlight}
          </Text>
        )}
      </Box>
    </Box>
  );
}
